import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScrolledToDirective } from './scrolled-to.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ScrolledToDirective],
  exports: [ScrolledToDirective],
})
export class ScrolledToModule {}
